import React, { useEffect, useState } from 'react'
import * as Yup from 'yup';
import DynamicForm from '../../../../../components/FormElements/DynamicForm';
import OptionsGenerator from '../../../../../components/OptionsGenerator';
import usePostApi from '../../../../../config/hooks/api/post/usePostApi';
import { setError, setMessage } from '../../../../../store/common/generalSlice';
import { useDispatch } from 'react-redux';
import TimePickerComponent from '../../../../../components/TimePicker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const Poll = ({ closeAddPost, refreshFeed, editData }) => {
    const { createPoll, updatePoll } = usePostApi()
    const dispatch = useDispatch()

    const [dataToUpdate, setDataToUpdate] = useState(null)

    // Define the schema for each object in the array
    const objectSchema = Yup.object().shape({
        id: Yup.number().required('Id is required'),
        value: Yup.string().required('Value is required')
    });

    // Define the form configuration
    const form = {
        name: 'addPollForm',
        formFields: [
            {
                name: 'question',
                type: 'text',
                label: { value: 'Your Question', style: '', classes: 'label-gray' },
                placeholder: 'How many cups of coffee do you consume?',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: '',
                icon: null
            },
            {
                name: 'options',
                type: 'custom',
                label: { value: 'Add your option', style: '', classes: 'label-gray' },
                placeholder: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: <OptionsGenerator limit={10} />,
                classes: '',
                icon: null
            },
            // {
            //     name: 'endTime',
            //     type: 'timepicker',
            //     label: { value: 'Poll Duration', style: '', classes: 'label-gray' },
            //     placeholder: 'End Time',
            //     width: { md: 12, sm: 12, xs: 12 },
            //     component: null,
            //     classes: 'custom-timepicker',
            //     icon: null
            // },
            {
                name: 'endTime',
                type: 'custom',
                label: { value: 'Poll Duration', style: '', classes: 'label-gray' },
                placeholder: 'End Time',
                width: { md: 12, sm: 12, xs: 12 },
                component: <TimePickerComponent />,
                classes: 'custom-timepicker',
                icon: null
            },
            {
                name: 'endDate',
                type: 'datepicker',
                label: { value: 'Poll Duration', style: '', classes: 'field' },
                placeholder: 'End Date',
                width: { md: 12, sm: 12, xs: 12 },
                component: null,
                classes: 'custom-datepicker',
                icon: null,
                maxDate: '',
                minDate: (new Date()).toISOString().split('T')[0]
            },
        ],
        formValidation: {
            question: Yup.string()
                .required('Question is required')
                .min(2, 'Question should be at least 2 character long')
                .max(500, 'Question should not exceed 500 characters'),
            options: Yup.array().of(objectSchema)
                .min(2, 'At least two options are required')
                .max(10, 'Should not exceed 10 options'),
            endTime: Yup.string()
                .required('Poll End Time is required'),
            endDate: Yup.string().required('Poll End Date is required'),
        },
    }


    const validateDateTime = (inputDateTime) => {
        // Parse the input date and time using dayjs
        const currentDate = dayjs().format('YYYY-MM-DD');
        const currentTime = dayjs().format('HH:mm');
        const utcTime = dayjs.utc(inputDateTime.split(' ')[1], 'HH:mm');
        const localTime = utcTime.local().format('HH:mm');
        
        const utcCurrentDateTime = dayjs(`${currentDate} ${currentTime}`).utc().format('YYYY-MM-DD HH:mm')
        const utcPollEndDateTime = dayjs(`${inputDateTime.split(' ')[0]} ${localTime}`).utc().format('YYYY-MM-DD HH:mm')

        // Parse the times using dayjs with the 'HH:mm' format
        const parsedUtcCurrentDateTime = dayjs(utcCurrentDateTime, 'YYYY-MM-DD HH:mm');
        const parsedUtcPollEndDateTime = dayjs(utcPollEndDateTime, 'YYYY-MM-DD HH:mm');

        // Validate if time1 is earlier than time2
        const validPollEndTime = parsedUtcCurrentDateTime.isBefore(parsedUtcPollEndDateTime);

        if(!validPollEndTime){
            return false
        }
        else{
            return utcPollEndDateTime
        }

    };

    const handleSubmit = async (values) => {
        try {
            if (values) {
                // Define the UTC time
                const selectedTime = values?.endTime;
                
                // Assume the date part remains the same (current date for example)
                const localTimeZone = dayjs.tz.guess(); // Get your local timezone
                const selectedDate = dayjs(values?.endDate).tz(localTimeZone).format('YYYY-MM-DD');

                // Convert UTC time to local time
                // Parse the local time assuming the current date and local timezone

                // Convert the local time to UTC
                const selectedPollEndDateTime = `${selectedDate} ${selectedTime}` 
                let final = validateDateTime(selectedPollEndDateTime)
                if(!final){
                    dispatch(setError('Poll end time should be greater than current date and time'))
                    return 
                }

                delete values.endTime
                let response;

                if (editData && editData.type.toLowerCase() == 'poll') {
                    response = await updatePoll({
                        ...values,
                        endDate: final,
                        options: values && values?.options.map(option => option.value)
                    }, editData?.id)
                }
                else {
                    response = await createPoll({
                        ...values,
                        endDate: final,
                        options: values && values?.options.map(option => option.value)
                    })
                }

                if (response) {
                    dispatch(setMessage(response?.data?.message))
                    setTimeout(() => {
                        refreshFeed()
                        closeAddPost()
                    }, 1000);
                }
            }
        } catch (error) {
            console.log(error)
        }
    };

    useEffect(() => {
        if (editData && editData.type.toLowerCase() == 'poll') {
            setDataToUpdate({
                question: editData?.question,
                options: editData?.pollOptions && editData?.pollOptions.length && editData?.pollOptions,
                endDate: dayjs(editData?.endDate, 'YYYY-MM-DD'),
                endTime: editData?.endTime
            })
        }
    }, [editData])


    return (
        <DynamicForm
            id='pollForm'
            onSubmit={handleSubmit}
            form={form}
            reset={true}
            editData={dataToUpdate}
        />
    )
}

export default Poll